import { z } from "zod";

export enum MaskingType {
  ALLOW = "allow",
  MASK = "mask",
  BLOCK = "block",
}

export const MaskDataItemSchema = z.object({
  label: z.string(),
  masking_type: z.nativeEnum(MaskingType),
  regex: z.string().optional(),
  default: z.string().optional(),
});

export interface MaskDataItem extends z.infer<typeof MaskDataItemSchema> {}

export interface MaskTypeMap {
  [key: string]: string;
}

// Get Mask Data API Response Schema
export const GetMaskDataResponseSchema = z.object({
  mask_data: z.array(MaskDataItemSchema),
});

export interface GetMaskDataResponse extends z.infer<typeof GetMaskDataResponseSchema> {}

// Legacy alias for backward compatibility
export const MaskDataResponseSchema = GetMaskDataResponseSchema;
export interface MaskDataResponse extends GetMaskDataResponse {}

// Set Mask Data Request Schema
export const SetMaskDataRequestSchema = z.object({
  mask_data: z.array(MaskDataItemSchema),
});

export interface SetMaskDataRequest extends z.infer<typeof SetMaskDataRequestSchema> {}

// Set Mask Data Response Schema
export const SetMaskDataResponseSchema = z.object({
  ok: z.boolean(),
  message: z.string().nullable().optional(),
});

export interface SetMaskDataResponse extends z.infer<typeof SetMaskDataResponseSchema> {}

// Re-export StandardResponseSchema as StandardApiResponseSchema for backward compatibility
export { StandardResponseSchema as StandardApiResponseSchema } from "@/helpers/types";
